(() => {
  const FREE_GIFT_VARIANT_ID = 52162370208011;
  const CART_ENDPOINT = "/cart.js";
  const ADD_TO_CART_ENDPOINT = "/cart/add.js";
  const CHANGE_CART_ENDPOINT = "/cart/change.js";

  async function normalizeFreeGiftQuantity(variantId) {
    const cart = await fetchCart();

    const freeGiftItem = cart.items.find(
      (item) => Number(item.variant_id) === Number(variantId)
    );

    if (!freeGiftItem) return;

    if (freeGiftItem.quantity > 1) {
      console.log("Normalizing free gift quantity to 1");

      await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: freeGiftItem.key,
          quantity: 1,
        }),
      });
    }
  }


  /**
   * Fetch the current cart
   */
  async function fetchCart() {
    const response = await fetch(CART_ENDPOINT);
    if (!response.ok) throw new Error("Failed to fetch cart");
    return response.json();
  }

  /**
   * Add a variant to cart
   */
  async function addToCart(variantId, quantity = 1) {
    const response = await fetch(ADD_TO_CART_ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity,
        properties: {
          [window.free_gift_key]: window.free_gift_value
        }
      })

    });
    console.log({response});
    
    if (!response.ok) throw new Error("Failed to add to cart");
    return response.json();
  }

  /**
   * Remove a variant from cart
   */
  /**
   * Remove a variant from cart
   */
  async function removeFromCart(variantId) {
    const cart = await fetchCart();
    const lineItem = cart.items.find((item) => item.id === variantId);

    if (!lineItem) {
      console.warn(`Variant ${variantId} not found in cart`);
      return cart;
    }

    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: lineItem.key, // ✅ must use line item key, not variantId
        quantity: 0,
      }),
    });

    if (!response.ok) throw new Error("Failed to remove from cart");
    return response.json();
  }

  async function refreshCartDrawerItems() {
    try {
      // Fetch cart drawer section
      const response = await fetch("/?sections=cart-drawer");
      if (!response.ok) throw new Error("Failed to fetch cart drawer section");

      const data = await response.json();

      // Get the HTML of the cart drawer section
      const parser = new DOMParser();
      const doc = parser.parseFromString(data["cart-drawer"], "text/html");

      // Grab the new cart items
      const newItems = doc.querySelector(".cart-drawer__items");

      // Replace the existing cart items
      const currentItems = document.querySelector(".cart-drawer__items");
      if (currentItems && newItems) {
        currentItems.replaceWith(newItems);
        console.log("Cart drawer items updated");
      }
    } catch (error) {
      console.error("refreshCartDrawerItems error:", error);
    }
  }

  /**
   * Ensure variant exists in cart
   */
  async function addToCartIfNotExists(variantId, quantity = 1) {
    try {
      const cart = await fetchCart();
      const alreadyInCart = cart.items.some((item) => item.id === variantId);
      const giftCardInCart = cart.items.some((item) => item.gift_card === true);
      const onlyTwoItems = cart.items.length === 2;

      const allGiftCards =
        cart.items.length > 0 &&
        cart.items.every((item) => item.gift_card === true);
      if (allGiftCards) {
        console.log("Cart has only gift cards - free gift not added.");
        return;
      }

      if (alreadyInCart && giftCardInCart && onlyTwoItems) {
        console.log(
          "Removing free gift because cart has only gift card + free gift"
        );
        await removeFromCart(variantId);
        await adjustCart();
        await refreshCartDrawerItems();
        return;
      }

      if (alreadyInCart) {
        await normalizeFreeGiftQuantity(variantId);
        console.log(`Variant ${variantId} already in cart.`);
      } else {
        const addedItem = await addToCart(variantId, quantity);
        console.log("Added to cart:", addedItem);
      }

      await adjustCart();
      await refreshCartDrawerItems();
    } catch (error) {
      console.error("addToCartIfNotExists error:", error);
    }
  }

  /**
   * Adjust cart UI based on conditions
   */
  async function adjustCart() {
    try {
      const cart = await fetchCart();
      const onlyGiftInCart =
        cart.items.length === 1 &&
        cart.items[0].variant_id === FREE_GIFT_VARIANT_ID;

      const cartDot = document.querySelector(".header__cart-dot");
      const cartDrawer = document.getElementById("cart-drawer");

      if (onlyGiftInCart) {
        cartDot?.classList.remove("is-visible");
        cartDrawer?.classList.add("drawer--center-body");
      }
    } catch (error) {
      console.error("adjustCart error:", error);
    }
  }

  /**
   * Event bindings
   */
  document.addEventListener("cart-drawer:refreshed", async () => {
    await adjustCart();
    await addToCartIfNotExists(FREE_GIFT_VARIANT_ID, 1);
  });

  addToCartIfNotExists(FREE_GIFT_VARIANT_ID, 1);
})();
